module.exports = __webpack_public_path__ + "img/2.c4d6bb3b.jpg";